import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import BookDetail from "@/pages/BookDetail";
import Cart from "@/pages/Cart";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Login, Register } from "@/pages/Auth";
import { Library, Wishlist, Orders } from "@/pages/UserPages";
import Audiobooks from "@/pages/Audiobooks";
import Author from "@/pages/Author";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import FAQ from "@/pages/FAQ";
import AuthCallback from "@/pages/AuthCallback";
import AuthorizePage from "@/pages/AuthorizePage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              {/* Standalone screens outside the Layout */}
              <Route path="/authorize" element={<AuthorizePage />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/livre/:id" element={<BookDetail />} />
                <Route path="/audiobooks" element={<Audiobooks />} />
                <Route path="/auteur" element={<Author />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/bibliotheque" element={<Library />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/commandes" element={<Orders />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
